// biome-ignore lint/style/noRestrictedImports: encapsulation
import { objOf } from "remeda";

import { unpurry } from "./_unpurry";

export const objectOf = unpurry(objOf, 2);
